var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurancePremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#1ECCB0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.345 15.5098C27.0963 15.2224 26.7479 15.0401 26.37 14.9998C24.7164 14.8265 23.1066 14.3618 21.615 13.6273C21.4236 13.5333 21.2132 13.4844 21 13.4844C20.7868 13.4844 20.5764 13.5333 20.385 13.6273C18.9043 14.3626 17.3042 14.8274 15.66 14.9998C15.2817 15.0328 14.9289 15.204 14.6688 15.4807C14.4087 15.7574 14.2596 16.1202 14.25 16.4998V20.2498C14.25 25.3048 19.3125 28.4998 21 28.4998C22.6875 28.4998 27.75 25.3123 27.75 20.2498V16.4998C27.7412 16.1312 27.5971 15.7788 27.345 15.5098ZM24.75 19.4998H24V20.2498C24 20.4487 23.921 20.6394 23.7803 20.7801C23.6397 20.9207 23.4489 20.9998 23.25 20.9998C23.0511 20.9998 22.8603 20.9207 22.7197 20.7801C22.579 20.6394 22.5 20.4487 22.5 20.2498V19.4998H21.75C21.5511 19.4998 21.3603 19.4207 21.2197 19.2801C21.079 19.1394 21 18.9487 21 18.7498C21 18.5508 21.079 18.3601 21.2197 18.2194C21.3603 18.0788 21.5511 17.9998 21.75 17.9998H22.5V17.2498C22.5 17.0508 22.579 16.8601 22.7197 16.7194C22.8603 16.5788 23.0511 16.4998 23.25 16.4998C23.4489 16.4998 23.6397 16.5788 23.7803 16.7194C23.921 16.8601 24 17.0508 24 17.2498V17.9998H24.75C24.9489 17.9998 25.1397 18.0788 25.2803 18.2194C25.421 18.3601 25.5 18.5508 25.5 18.7498C25.5 18.9487 25.421 19.1394 25.2803 19.2801C25.1397 19.4207 24.9489 19.4998 24.75 19.4998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurancePremium);
export default __webpack_public_path__ + "static/media/insurance_premium.bb2a5f5452b4e0d07af96bc5d039700c.svg";
export { ForwardRef as ReactComponent };